import React from 'react';
import { OperationProgress } from '../../../../components/OperationProgress/OperationProgress';
import { useOTCCheckDifferencesProgress } from '../../../../store/otcProgressStore';

interface OTCCheckProgressProps {
  onRetryFailed?: () => void;
  retryCount?: number;
}

export const OTCCheckProgress: React.FC<OTCCheckProgressProps> = ({
  onRetryFailed,
  retryCount,
}) => {
  return (
    <OperationProgress
      titles={{
        inProgress: 'Checking OTC differences...',
        complete: 'Check Complete',
      }}
      useStore={useOTCCheckDifferencesProgress}
      onRetryFailed={onRetryFailed}
      retryCount={retryCount}
    />
  );
};
